import React from 'react';

const SplashScreen = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-400 via-red-400 to-pink-400 flex items-center justify-center">
      <div className="text-center">
        {/* Logo/Icon */}
        <div className="w-32 h-32 bg-white bg-opacity-20 rounded-3xl mx-auto mb-8 flex items-center justify-center backdrop-blur-sm">
          <img
            src="/themaithil_logo.png"
            alt="TheMaithil logo"
            className="w-16 h-16 object-contain"
          />
        </div>

        {/* App Name */}
        <h1 className="text-4xl font-bold text-white mb-4">PanditJee</h1>
        
        {/* Tagline */}
        <p className="text-white text-lg font-medium mb-2">Shraddha se Seva,</p>
        <p className="text-white text-lg font-medium">Har Ghar Mein Pooja</p>
        
        {/* Loading indicator */}
        <div className="mt-12">
          <div className="w-8 h-8 border-4 border-white border-t-transparent rounded-full animate-spin mx-auto"></div>
        </div>
      </div>
    </div>
  );
};

export default SplashScreen;
